module.exports = __webpack_public_path__ + "static/media/card-content-image.dee4303a.svg";